import { render, staticRenderFns } from "./AssociationModule.vue?vue&type=template&id=4c727bd5&scoped=true"
import script from "./AssociationModule.vue?vue&type=script&lang=js"
export * from "./AssociationModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c727bd5",
  null
  
)

export default component.exports